var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('head'),_c('NavigationBar'),_c('v-main',[_c('router-view'),_c('CookieBanner')],1),_c('FooterComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }